module.exports = __webpack_public_path__ + "static/media/logo.095aa725.svg";